import { render, staticRenderFns } from "./DataCaptureTab.vue?vue&type=template&id=ffd4038c&"
import script from "./DataCaptureTab.vue?vue&type=script&lang=ts&"
export * from "./DataCaptureTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffd4038c')) {
      api.createRecord('ffd4038c', component.options)
    } else {
      api.reload('ffd4038c', component.options)
    }
    module.hot.accept("./DataCaptureTab.vue?vue&type=template&id=ffd4038c&", function () {
      api.rerender('ffd4038c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/DataCaptureTab.vue"
export default component.exports